import dayjs from 'dayjs';

export const getFormattedDate = (datetime) => dayjs(datetime).format('YYYY-MM-DD');

export function removeDuplicateDates(dates) {
  const uniqueDates = [];

  return dates.filter((dateString) => {
    if (!uniqueDates.includes(dateString)) {
      uniqueDates.push(dateString);
      return true;
    }

    return false;
  });
}

export function getCaseManagerProposedDates(proposedChanges = []) {
  return proposedChanges
    .filter(({ status, createdBy, value }) => status === 'reviewed' && createdBy === 'case-manager' && value)
    .map(({ value }) => value);
}

export function getUniqueCaseManagerProposedDates(invitations) {
  const datesProposedByCaseManagers = invitations
    .filter(({ status }) => status === 'review')
    .map((invitation) => getCaseManagerProposedDates(invitation?.proposedChanges))
    .flat()
    .sort();

  const uniqueDates = [...new Set(datesProposedByCaseManagers)];
  return uniqueDates;
}

const hasCaseManagerReviewedProposedDates = ({ proposedChanges }) =>
  proposedChanges
    .filter(({ status, updatedBy, value }) => status === 'reviewed' && updatedBy === 'case-manager' && value)
    .map(({ value }) => getFormattedDate(value));

const hasProposedChangesMatchingDate = (proposedChanges, dateSelected) =>
  proposedChanges.some(({ value }) => dayjs(value).isSame(dayjs(dateSelected), 'day'));

const hasReviewStatus = ({ status }) => status === 'review';

export function getInvitesInReviewMatchingTheDate(invites, dateSelected) {
  return invites
    .filter(hasReviewStatus)
    .filter(({ proposedChanges }) => hasProposedChangesMatchingDate(proposedChanges, dateSelected))
    .filter(hasCaseManagerReviewedProposedDates);
}
